import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AppFrame from "../../Appframe/AppFrame";

import sort from "fast-sort";

import { Paper, Button } from "@material-ui/core";

import RTMService from "../../../services/rtm";
import loadingGif from "../../../resources/images/loading.gif";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import colors, { colorsV2 } from "../../../styles/colors";
import Title from "../../../components/common/Title";

const OrganizationRTMReport = (props) => {
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const printReport = () => {
    let containerEl = document.createElement("div");
    const input = document.getElementById("reportContainer");
    let inputClone = input.cloneNode(true);
    input.appendChild(inputClone);
    containerEl.appendChild(inputClone);
    let externalWindow = window.open(
      "",
      "",
      "width=1000,height=600,left=200,top=200"
    );
    externalWindow.document.body.appendChild(containerEl);
    //Trigger automatic print and close window after.
    externalWindow.onafterprint = () => {
      externalWindow.close();
    };
    setTimeout(() => {
      externalWindow.print();
    }, 3000);
  };

  const classes = makeStyles({
    table: {
      minWidth: 650,
    },
    colHeader: {
      textAlign: "right",
      verticalAlign: "bottom",
      writingMode: "vertical-rl",
      transform: "rotate(180deg)",
    },
  });

  useEffect(() => {
    //Run on load
    if (props.organization && props.organization.orgId) {
      setIsLoading(true);
      RTMService()
        .getRTMListForOrg(props.organization.orgId)
        .then((response) => {
          setReportData(response.rtmRecordList);
          setIsLoading(false);
        });
    }
  }, [props.organization]);

  let lastProvider = null;
  let lastProviderName = null;

  const olderThanSixteenDays = (date) => {
    const today = new Date();
    const priorDate = new Date(new Date().setDate(today.getDate() - 16));
    return new Date(date) < priorDate;
  };

  const getStatusForUser = () => {
    const five = getStatusForSevenFive();
    const seven = getStatusForSevenSeven();
    const zero = getStatusForEightOne();
    const one = getStatusForEightZero();
    return five || seven || zero || one;
  };

  const getStatusForSevenFive = (row) => {
    if (row.sevenFiveBilledFor) {
      return false;
    } else if (row.hasPatientActivity && olderThanSixteenDays(row.dateOfEval)) {
      return true;
    } else if (row.userInfo.profilePhotoUrl !== undefined) {
      // return "Call active patient - check in";
      return false;
    } else {
      // return "No Action Needed";
      return false;
    }
  };

  const getStatusForSevenSeven = (row) => {
    if (row.sevenSevenBilledFor) {
      return false;
    } else if (row.hasPatientActivity && olderThanSixteenDays(row.dateOfEval)) {
      return true;
    } else if (row.userInfo.profilePhotoUrl !== undefined) {
      // return "Call active patient - check in";
      return false;
    } else {
      // return "No Action Needed";
      return false;
    }
  };

  const getStatusForEightZero = (row) => {
    if (row.eightZeroBilledFor) {
      return false;
    } else if (row.minutesInChartThisMonth > 20) {
      return true;
    }

    return false;
  };

  const getStatusForEightOne = (row) => {
    if (row.eightOneBilledFor) {
      return false;
    } else if (row.minutesInChartThisMonth > 40) {
      return true;
    }

    return false;
  };

  return (
    <AppFrame
      auth={props.auth}
      header="RTM Billing"
      optionsType="organizationReporting"
      whiteLabelSettings={props.whiteLabelSettings}
    >
      <Title text1="" text2="" goBack={() => props.history.goBack()} />
      {isLoading && (
        <Paper
          style={{
            margin: 30,
            padding: 20,
            borderColor: colorsV2.primary,
            borderWidth: 2,
            borderStyle: "solid",
          }}
          elevation={3}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h1>Generating Report....</h1>
              <p>
                Report may take a few minutes to complete, please be patient.
              </p>
            </div>
            <div>
              <img
                src={loadingGif}
                alt="Loading..."
                style={{ marginLeft: "auto", marginRight: "auto", width: 150 }}
              />
            </div>
          </div>
        </Paper>
      )}
      {reportData && reportData.length > 0 && (
        <Paper
          style={{
            margin: 30,
            padding: 20,
            borderColor: colorsV2.primary,
            borderWidth: 2,
            borderStyle: "solid",
          }}
          elevation={3}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                printReport();
              }}
              style={{ marginBottom: 20 }}
            >
              Print Report
            </Button>
          </div>
          <div id="reportContainer">
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{
                        backgroundColor: colors.primary,
                        color: "white",
                      }}
                    >
                      Provider
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{
                        backgroundColor: colors.primary,
                        color: "white",
                      }}
                    >
                      Patient
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: colors.primary,
                        color: "white",
                      }}
                    >
                      Date Of Eval
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: colors.primary,
                        color: "white",
                      }}
                    >
                      98975
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: colors.primary,
                        color: "white",
                      }}
                    >
                      98977/989X6
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: colors.primary,
                        color: "white",
                      }}
                    >
                      98980
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: colors.primary,
                        color: "white",
                      }}
                    >
                      98981
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData != null &&
                    reportData.map((row) => {
                      //Only display the provider name once
                      let lastProviderName = "";
                      if (lastProvider !== row.appId) {
                        lastProvider = row.appId;
                        lastProviderName =
                          row.firstName +
                          " " +
                          row.lastName +
                          " - " +
                          row.appName;
                      }

                      let sevenFive = "Incomplete";
                      if (row.sevenFiveBilledFor) {
                        sevenFive = "Complete";
                      } else if (getStatusForSevenFive(row)) {
                        sevenFive = "Ready To Bill";
                      } else {
                        sevenFive = "Incomplete";
                      }

                      let sevenSeven = "Incomplete";
                      if (row.sevenSevenBilledFor) {
                        sevenSeven = "Complete";
                      } else if (getStatusForSevenFive(row)) {
                        sevenSeven = "Ready To Bill";
                      }
                      let eightZero = "Incomplete";
                      if (row.eightZeroBilledFor) {
                        eightZero = "Complete";
                      } else if (getStatusForEightZero(row)) {
                        eightZero = "Ready To Bill";
                      }
                      let eightOne = "Incomplete";
                      if (row.eightOneBilledFor) {
                        eightZero = "Complete";
                      } else if (getStatusForEightOne(row)) {
                        eightZero = "Ready To Bill";
                      }

                      return (
                        <React.Fragment>
                          {lastProviderName !== "" && (
                            <TableRow>
                              <TableCell
                                scope="row"
                                colSpan={7}
                                align="left"
                                style={{ borderBottom: "2px black solid" }}
                              >
                                {lastProviderName}
                              </TableCell>
                            </TableRow>
                          )}
                          <TableRow key={row.eventId} className={classes.row}>
                            <TableCell
                              align="right"
                              colspan={2}
                              style={{
                                backgroundColor: "#F2F2F2",
                                borderRight: "solid 2px black",
                              }}
                            >
                              {row.patientFirstName + " " + row.patientLastName}
                            </TableCell>
                            <TableCell align="left">{row.dateOfEval}</TableCell>
                            <TableCell
                              align="left"
                              style={{
                                backgroundColor:
                                  sevenFive === "Ready To Bill"
                                    ? "yellow"
                                    : null,
                              }}
                            >
                              {sevenFive}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                backgroundColor:
                                  sevenSeven === "Ready To Bill"
                                    ? "yellow"
                                    : null,
                              }}
                            >
                              {sevenSeven}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                backgroundColor:
                                  eightZero === "Ready To Bill"
                                    ? "yellow"
                                    : null,
                              }}
                            >
                              {eightZero}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                backgroundColor:
                                  eightOne === "Ready To Bill"
                                    ? "yellow"
                                    : null,
                              }}
                            >
                              {eightOne}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Paper>
      )}
    </AppFrame>
  );
};

function mapStateToProps({ user, organization, whiteLabelSettings }, props) {
  return { user, organization, whiteLabelSettings, ...props };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, null)(OrganizationRTMReport);



// WEBPACK FOOTER //
// ./src/layout/reporting/OrgReporting/OrganizationRTMReport.js